import script from "./MainButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MainButton.vue?vue&type=script&setup=true&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=0e70c23f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e70c23f"]])

export default __exports__